import { isCan } from "@/tools";
import { ZONA } from "@/const";

const store = {
  namespaced: true,
  getters: {
    // eslint-disable-next-line
    instansi_id(state, getters, rootState, rootGetters) {
      const i = rootGetters["instansi/instansi_aktif"];
      return i ? i.id : null;
    },
    // eslint-disable-next-line
    kelas_id_verval(state, getters, rootState, rootGetters) {
      return ZONA == "RIIL" ? 990 : 257;
    },
    // eslint-disable-next-line
    menus(state, getters, rootState, rootGetters) {
      // const d = rootGetters["diklat/diklat"];
      const u = rootGetters["user/user"];
      // list menu
      let menu = [
        {
          icon: "mdi-swap-horizontal",
          title: "Daftar Ujian",
          to: {
            name: "instansi.pilih.admin"
          },
          hidden: false
        },
        {
          icon: "mdi-book-open",
          title: "Diklat",
          to: {
            name: "diklat",
            params: {
              instansi_id: getters["instansi_id"]
            }
          },
          hidden: !u.is_super_admin
        },
        {
          icon: "mdi-home-account",
          title: "Jenis Kegiatan",
          hidden: !u.is_super_admin,
          to: {
            name: "jenis-kelas",
            params: {
              instansi_id: getters["instansi_id"]
            }
          }
        },
        {
          icon: "mdi-calendar",
          title: "Sesi",
          hidden: !u.is_super_admin,
          to: {
            name: "angkatan",
            params: {
              instansi_id: getters["instansi_id"]
            }
          }
        },
        {
          icon: "mdi-google-classroom",
          title: "Jadwal",
          hidden: !isCan("kelas-read"),
          to: {
            name: "kelas",
            params: {
              instansi_id: getters["instansi_id"]
            }
          }
        },
        // {
        //   icon: "mdi-account-check",
        //   title: "Verval Peserta",
        //   hidden: !isCan("verval-read"),
        //   to: {
        //     name: "peserta.verval",
        //     params: {
        //       instansi_id: getters["instansi_id"],
        //       kelas_id: getters["kelas_id_verval"]
        //     }
        //   }
        // },

        {
          icon: "mdi-account-group",
          title: "Peserta Kelas",
          hidden: !isCan("pengguna-read"),
          to: {
            name: "peserta-kelas",
            params: {
              instansi_id: getters["instansi_id"]
            }
          }
        },
        {
          icon: "mdi-account-group",
          title: "Pengelola",
          hidden: !isCan("pengguna-read"),
          to: {
            name: "pengelola-kelas",
            params: {
              instansi_id: getters["instansi_id"]
            }
          }
        }
      ];

      return menu;
    }
  }
};

export default store;
